export default __webpack_public_path__ + "static/media/mitigation-bathroom-damage-view-2.188ab1d0.jpg";